import { TFunction } from 'i18next'

export const mapEnumToOptions = <T extends string>(
  labelsByValue: Record<T, string>
) =>
  Object.entries<string>(labelsByValue).map(([value, label]) => ({
    label,
    value
  }))

export const getMonthsOptions = (t: TFunction) => [
  { label: t('common.months.january'), value: '1' },
  { label: t('common.months.february'), value: '2' },
  { label: t('common.months.march'), value: '3' },
  { label: t('common.months.april'), value: '4' },
  { label: t('common.months.may'), value: '5' },
  { label: t('common.months.june'), value: '6' },
  { label: t('common.months.july'), value: '7' },
  { label: t('common.months.august'), value: '8' },
  { label: t('common.months.september'), value: '9' },
  { label: t('common.months.october'), value: '10' },
  { label: t('common.months.november'), value: '11' },
  { label: t('common.months.december'), value: '12' }
]
